import { me as service } from '../base/services';
import Endpoint from '../base/endpoint';

const fetchNetworkToken = new Endpoint(service, 'post', '/network-token/{{networkId}}', {
  withCredentials: true
});
const fetchTokenByTicket = new Endpoint(service, 'post', '/token-by-ticket/{{ticket}}', {
  withCredentials: true
});
const login = new Endpoint(service, 'post', '/login');
const loginRegistered = new Endpoint(service, 'post', '/login-registered', {
  withCredentials: true
});
const logout = new Endpoint(service, 'post', '/logout');
const getMyMultiSpots = new Endpoint(service, 'get', '/multi/spots');
const getNetworkIdByName = new Endpoint(service, 'get', '/network-id-by-name/{{networkName}}');
const getNetworkIdBySpotId = new Endpoint(service, 'get', '/network-id-by-spot-id/{{spotId}}');
const getRoles = new Endpoint(service, 'get', '/token-roles');

export default {
  fetchNetworkToken,
  fetchTokenByTicket,
  login,
  loginRegistered,
  logout,
  getNetworkIdByName,
  getNetworkIdBySpotId,
  getRoles,
  getMyMultiSpots
};
